import { reportingValue } from "../values/decimal-reporting";
import { DECIMAL_CONFIG, decimalMultiply, decimalRound, decimalSubtract, type DecimalValue } from "../values/decimal";

type Price = DecimalValue | null | undefined;

export function roundMoney(value: DecimalValue): DecimalValue {
  return reportingValue(decimalRound(value, DECIMAL_CONFIG.moneyDecimalPlaces));
}

export function isMissingOrderPrice(pricePerItem: Price): boolean {
  return pricePerItem == null || pricePerItem === "";
}

export function orderValue(pricePerItem: Price, quantity: DecimalValue): DecimalValue | null {
  if (isMissingOrderPrice(pricePerItem)) return null;
  return roundMoney(decimalMultiply(pricePerItem!, quantity));
}

export function orderBalance(pricePerItem: Price, quantity: DecimalValue, paid: DecimalValue): DecimalValue | null {
  if (isMissingOrderPrice(pricePerItem)) return null;
  return roundMoney(decimalSubtract(decimalMultiply(pricePerItem!, quantity), paid));
}
